import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash.isequal';
import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import selectors from './text/selectors.js';
import { creators } from './text/actions.js';

/* eslint-disable react/no-danger */
var RemoteJsonText = function RemoteJsonText(_ref) {
  var url = _ref.url,
    linkColor = _ref.linkColor,
    style = _ref.style;
  var dispatch = useDispatch();
  var json = useSelector(function (state) {
    return selectors.getJsonFile(state, url);
  }, isEqual);
  var isFetching = useSelector(function (state) {
    return selectors.isFetchingJson(state, url);
  }, isEqual);
  useEffect(function () {
    if (!isFetching && url && !json && !(json !== null && json !== void 0 && json.error)) {
      dispatch(creators.fetchJson({
        payload: {
          url: url
        }
      }));
    }
  }, [isFetching, JSON.stringify(json)]);
  if (!json || json !== null && json !== void 0 && json.error) {
    return null;
  }
  var _ref2 = json || {},
    _ref2$description = _ref2.description,
    description = _ref2$description === void 0 ? '' : _ref2$description,
    _ref2$feature_list = _ref2.feature_list,
    featureList = _ref2$feature_list === void 0 ? [] : _ref2$feature_list;
  return /*#__PURE__*/React.createElement(React.Fragment, null, description && /*#__PURE__*/React.createElement("p", null, description), /*#__PURE__*/React.createElement("ul", {
    className: style.list
  }, featureList.map(function (item, i) {
    return /*#__PURE__*/React.createElement("li", {
      key: i
    }, /*#__PURE__*/React.createElement("i", {
      className: cx(style.icon, 'icon-icon_checkmark'),
      style: {
        color: linkColor
      }
    }), item.label, item.detail && /*#__PURE__*/React.createElement("span", null, item.detail));
  })));
};
RemoteJsonText.defaultProps = {
  // options: {},
};
RemoteJsonText.propTypes = {
  url: PropTypes.string.isRequired,
  linkColor: PropTypes.any.isRequired,
  style: PropTypes.any.isRequired
};
var MemoizedRemoteJsonText = /*#__PURE__*/React.memo(RemoteJsonText);
var MemoizedRemoteJsonText$1 = MemoizedRemoteJsonText;

export { MemoizedRemoteJsonText$1 as default };
//# sourceMappingURL=RemoteJsonText.js.map
